import P1 from '@/static/images/news/1.png'
import P2 from '@/static/images/news/2.png'
import P3 from '@/static/images/news/3.png'
import P4 from '@/static/images/news/4.png'
import P5 from '@/static/images/news/5.png'
import P6 from '@/static/images/news/6.png'
import P7 from '@/static/images/news/7.png'
import P8 from '@/static/images/news/8.png'
import P9 from '@/static/images/news/9.png'
import P10 from '@/static/images/news/10.png'
import P11 from '@/static/images/news/11.png'
import P12 from '@/static/images/news/12.png'

import Blog from '@/static/images/news/Blog.png'
import Coinspeaker from '@/static/images/news/Coinspeaker.png'
import Cointelegraph from '@/static/images/news/Cointelegraph.png'

import N1 from '@/static/images/news/n1.png'
import N2 from '@/static/images/news/n2.png'

export const TopInfo = {
  id: 0,
  link: 'https://www.coinspeaker.com/multi-chain-web3-infrastructure-dmail-closes-pre-a-round/',
  title: 'Multi-chain Web3 Infrastructure Dmail Closes Pre-A Round',
  thumb: P1,
  desc: 'Recently, Dmail, the multi-chain infrastructure, closes its Pre-A Round. Dmail Network has completed its seed and strategic round before',
  ava: Coinspeaker,
  name: 'Coinspeaker',
  date: 'July 25th, 2023',
  content: [
    // `Recently, Dmail, the multi-chain infrastructure, closes its Pre-A Round. Dmail Network has completed its seed and strategic round before, and attracted more than 550K active users while successfully partnering with Hashkey Capital, Draper Dragon, Outliers Fund, Parallel Ventures, Spark Digital Capital and other illustrious institutions, while building a solid partnership with the well-known venture capital firm Amino. Dmail has been recognized globally due to its outstanding performance and delivery.`,
    // `Till now, Dmail has made many powerful partnerships with the likes of Amino Capital, OIG VC, Draper Dragon, KuCoin Labs, HG Ventures, Spark Digital Capital, Vespertine Capital, BiXin Ventures, LoneLine, Lead Capital, TsingTing Capital, Wagmi Venture, Catcher VC, Gate Labs, Kretos Ventures, Black Ventures and Red Swiss. Many outstanding professionals who worked at Google are now part of Dmail, as well as some individual supporters from the blockchain industry who are (co)founders and core executives.`,
    // { text: `Dmail Network integrates message communication, asset management, data storage, subscriptions & notifications, Web3 marketing and an AI assistant as part of its excellent infrastructure, with a highly secure and user-friendly platform which provides the best possible service for users. Furthermore, Dmail will attract more users and partners by connecting Web2 and Web3 functions with blockchain services.` },
    // `As a leader in AI-powered decentralized multi-chain infrastructure, Dmail Network provides unified, real-time messaging and notification services across multiple chains and applications. The mission is to keep users informed and connected in the digital landscape, enabling effortless and seamless access to data and messages.`,
    // `James, co-founder of Dmail, said:`,
    // `<i>"I'm honored to work with such wonderful and passionate partners. I have conviction that Dmail Network will revolutionize the way traditional email is served, and will bring a decentralized, secure experience for users, ensuring mass adoption as the next iteration of email services. This funding will be used primarily for technology and product development, expansion of our teams in the U.S. and Korea, and marketing. In addition, in the face of the current and future impact of weakening global asset liquidity, Dmail will turn its attention to product iteration and technology research. Therefore, we will invest more funds and energy in decentralized storage, multi-chain ecosystems, messaging protocols and AI personal agents, while continuing to promote the construction of Dmail’s mainnet."<i/>`,
    // `Since the launch of Beta Network on June 1, 2022, Dmail has gained nearly 550,000 registered domain accounts, with over 300,000 individual addresses, achieving a cumulative total of 8.5 Million messages and 100+ external partnerships, like Worldcoin, ENS, SpaceID, Lens, zkSync Era, BNB Chain and etc.`,
    // { nav: 'About Dmail Network', text: `<h2>About Dmail Network</h2>` },
    // `Dmail Network is building an AI-powered decentralized infrastructure which allows users to stay informed and connected with intelligent, seamless messaging and notifications.`,
  ],
}

export const NewsList = [
  {
    id: 1,
    link: 'https://cointelegraph.com/press-releases/dmail-launches-subscription-hub-revolutionizing-web3-communication',
    title: 'Dmail launches Subscription & Notification: Revolutionizing Web3 communication',
    thumb: P2,
    desc: 'Dmail Network, a pioneer in Web3 communication solutions, announced the launch of its groundbreaking feature — Subscription & Notification — on October 25th. ',
    ava: Cointelegraph,
    name: 'Cointelegraph',
    date: 'November 3th, 2023',
    content: [
    ],
  },
  {
    id: 2,
    link: 'https://twitter.com/Coin98Analytics/status/1715301712221835683',
    title: 'Many new #SocialFi projects now rank among the top 15 by 30D unique active addresses this month',
    thumb: P3,
    desc: 'Many new #SocialFi projects now rank among the top 15 by 30D unique active addresses this month',
    ava: 'https://pbs.twimg.com/profile_images/1379395162099490822/uy6oE80i_x96.jpg',
    name: 'Coin98 Analytics',
    date: 'October 20th, 2023',
    content: [
    ],
  },
  {
    id: 1000,
    link: 'https://twitter.com/Coin98Analytics/status/1727942589255692461',
    title: '#GameFi, #DEX, #Brigge, and #SocialFi are among the most notable sectors.',
    thumb: P11,
    desc: 'There are up to 8 #GameFi projects that have made it into the top Dapps with an impressive number of unique active addresses',
    ava: 'https://pbs.twimg.com/profile_images/1379395162099490822/uy6oE80i_x96.jpg',
    name: 'Coin98 Analytics',
    date: 'Nov 24th, 2023',
    content: [
    ],
  },
  {
    id: 1001,
    link: 'https://twitter.com/layer2gather/status/1729183391457976493',
    title: 'Dmail led with an astonishing 195K UAW',
    thumb: P12,
    desc: 'Top #SocialFi on Layer 2 by Unique Active Wallets in 7D',
    ava: 'https://pbs.twimg.com/profile_images/1663779609819885568/uAMSb_90_x96.jpg',
    name: 'Layer2Gather',
    date: 'Nov 27th, 2023',
    content: [
    ],
  },
  {
    id: 3,
    link: 'https://twitter.com/BaseDailyTK/status/1718939190237495331',
    title: 'Ecosystem Weekly Dashboard',
    thumb: P4,
    desc: 'Congratulations to all the projects that have built up a record and had impressive growth in the past week',
    ava: 'https://pbs.twimg.com/profile_images/1717729201967779840/TbqfAsLz_x96.jpg',
    name: 'Base Daily',
    date: 'October 30th, 2023',
    content: [
    ],
  },
  {
    id: 4,
    link: 'https://twitter.com/bsc_daily/status/1717777214065029202',
    title: 'The Fastest Growing Communities on #BNBChain Last 30 Days',
    thumb: P5,
    desc: 'Congratulations on great projects with strong growth',
    ava: 'https://pbs.twimg.com/profile_images/1717728315715600384/bJSlxOtT_x96.jpg',
    name: 'BSCDaily',
    date: 'October 27th, 2023',
    content: [
    ],
  },
  {
    id: 5,
    link: 'https://twitter.com/bsc_daily/status/1715675817999823011',
    title: 'Leading #SocialFi Projects with Highest Monthly Active Users',
    thumb: P6,
    desc: 'Which is your favorite SocialFi project on this list!?',
    ava: 'https://pbs.twimg.com/profile_images/1717728315715600384/bJSlxOtT_x96.jpg',
    name: 'BSCDaily',
    date: 'October 21th, 2023',
    content: [
    ],
  },
  {
    id: 6,
    link: 'https://twitter.com/Coin98Analytics/status/1717818769261896114',
    title: `Subscription & Notification - the gateway to connect with Dmail Network's 3.5M registered users for personalized marketing and communication!`,
    thumb: P7,
    desc: `Subscription & Notification - the gateway to connect with Dmail Network's 3.5M registered users for personalized marketing and communication!`,
    ava: 'https://pbs.twimg.com/profile_images/1379395162099490822/uy6oE80i_x96.jpg',
    name: 'Coin98 Analytics',
    date: 'October 27th, 2023',
    content: [
    ],
  },
  {
    id: 7,
    link: 'https://twitter.com/CryptoRank_io/status/1712832255972762037',
    title: 'Top 15 DApps by 30D Active Users on #zkSyncEra',
    thumb: P8,
    desc: 'Top 15 DApps by 30D Active Users on #zkSyncEra',
    ava: 'https://pbs.twimg.com/profile_images/1637764414421237760/JrPBVStG_x96.jpg',
    name: 'CryptoRank Platform',
    date: 'October 13th, 2023',
    content: [
    ],
  },
  {
    id: 8,
    link: 'https://twitter.com/ETH_Daily/status/1711407281219236161',
    title: 'What do you think is the best #SocialFi project on the crypto market right now!?',
    thumb: P9,
    desc: 'What do you think is the best #SocialFi project on the crypto market right now!?',
    ava: 'https://pbs.twimg.com/profile_images/1717728971188817920/yKz43j10_x96.jpg',
    name: 'Ethereum Daily',
    date: 'October 9th, 2023',
    content: [
    ],
  },
  {
    id: 9,
    link: 'https://blog.dmail.ai/dmail-integrates-worldcoin-into-its-burgeoning-digital-identity-infrastructure-2/',
    title: 'Dmail Integrates Worldcoin into its Burgeoning Digital Identity Infrastructure',
    thumb: P10,
    desc: 'Worldcoin has recently been integrated into the Dmail cross-chain communications ecosystem in order to expand the network and move further toward building a world-class digital citizenship infrastructure',
    ava: Blog,
    name: 'Dmail',
    date: 'May 25th, 2023',
    content: [
    ],
  },
]

export const SplitedNewsList = NewsList.reduce((arr, item, index) => {
  if (index % 3 === 0) {
    arr.push([])
  }
  arr[arr.length - 1].push(item)
  return arr
}, [])

// use id, not the index
// export const HomeNewsList = [TopInfo, ...[1, 2].map(id => NewsList.filter((item) => item.id == id)[0])]
export const HomeNewsList = [
  {
    id: 0,
    link: 'https://blog.dmail.ai/dmail-networks-brand-upgrade-and-mainnet-launch/',
    title: "Dmail Network's Brand Upgrade and Mainnet Launch",
    thumb: N1,
    desc: "Dmail Network's mainnet launch and brand upgrade mark the beginning of a new chapter in our mission to redefine decentralized communication.",
  },
  {
    id: 1,
    link: 'https://cointelegraph.com/press-releases/dmail-launches-subscription-hub-revolutionizing-web3-communication',
    title: 'Dmail launches Subscription & Notification: Revolutionizing Web3 communication',
    thumb: P2,
    desc: 'Dmail Network, a pioneer in Web3 communication solutions, announced the launch of its groundbreaking feature — Subscription & Notification — on October 25th. ',
    // ava: Cointelegraph,
    // name: 'Cointelegraph',
    // date: 'November 3th, 2023',
    // content: [
    // ],
  },
  {
    id: 2,
    link: 'https://blog.dmail.ai/dmails-plans-for-2025-the-future-of-web3-communication/',
    title: "Dmail's Plans for 2025: The Future of Web3 Communication",
    thumb: N2,
    desc: "New Year- New, refined vision. 2025 will be the year that Dmail becomes truly mass adopted, with a 100 million user target by the end of the year!",
  }
]
